<template>
  <div class="app-mobile-wrap back-grey">
    <div class="container">
      <div class="app-mobile">
        <div class="app-mobile__content">
          <div class="app-mobile__qr">
            <ui-image
              :file-data="{ fileId: mainFields?.qr?.value }"
              :picture-type="'preview'"
              :alt="mainFields?.title?.value"
              :title="mainFields?.title?.value"
              :loading="'lazy'"
            />
          </div>
          <div class="app-mobile__info">
            <div class="head-title">
              {{ mainFields?.title?.value }}
            </div>
            <div class="app-mobile__text">
              {{ mainFields.description?.value }}
            </div>
            <div class="app">
              <a href="https://apps.apple.com/ru/app/%D0%B5%D0%B2%D1%80%D0%BE%D0%B0%D0%BB%D1%8C%D1%8F%D0%BD%D1%81/id1591369936?platform=iphone" class="app-link app-link--color">
                <img
                  src="/img/app-store-color.svg"
                  alt=""
                  width="146"
                  height="46"
                  loading="lazy"
                >
              </a>
            </div>
          </div>
        </div>
        <div class="app-mobile__aside md-hidden">
          <div class="app-mobile__image">
            <ui-image
              :file-data="{ fileId: mainFields?.appIcon?.value }"
              :picture-type="'preview'"
              :alt="mainFields?.title?.value"
              :title="mainFields?.title?.value"
              :loading="'lazy'"
              img-width="347"
              img-height="404"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  mixins: [staticBlockMixin]
}
</script>
